export default __webpack_public_path__ + "808f2738311456e5eec42a382c0f3eef.svg";